import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { WhatsappTemplateCategory } from '@campaign-portal/namespace/common/enums';
import { TOOLTIP_COMPONENT_DATA } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-whatsapp-category',
	imports: [TranslateModule],
	templateUrl: './whatsapp-category.component.html',
	styleUrl: './whatsapp-category.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsappCategoryComponent {
	readonly data = {
		[WhatsappTemplateCategory.MARKETING]: {
			type: 'enums.MARKETING',
			options: [
				'whatsapp.awarenessBusiness',
				'whatsapp.sales',
				'whatsapp.retargeting',
				'whatsapp.appPromotion',
				'whatsapp.relationships',
			],
		},
		[WhatsappTemplateCategory.UTILITY]: {
			type: 'enums.UTILITY',
			options: [
				'whatsapp.optInManagement',
				'whatsapp.orderManagement',
				'whatsapp.accountAlerts',
				'whatsapp.feedback',
				'whatsapp.conversation',
			],
		},
		[WhatsappTemplateCategory.AUTHENTICATION]: {
			type: 'enums.AUTHENTICATION',
			options: ['whatsapp.authentication'],
		},
	};

	constructor(@Inject(TOOLTIP_COMPONENT_DATA) public readonly category: WhatsappTemplateCategory) {}
}
